import {getActivePinia} from 'pinia'
import {useUserStore} from '@/store/user'

/**
 * Intended auth provider from the `auth_provider` cookie. Signals INTENT only
 * (which flow a logged-out user should start), so use it for the login button.
 */
export function isKeycloakAuth(): boolean {
  return true
}

// Persisted user store blob (key defaults to the store id). Fallback for reading the
// session before Pinia is ready (the early auth plugin runs before Pinia).
const PERSISTED_USER_KEY = 'UserModule'

function getPersistedUserSession(): {accessToken?: string; loggedInUsingKeycloakFlow?: boolean} {
  if (!process.client) {
    return {}
  }

  try {
    const raw = window.localStorage.getItem(PERSISTED_USER_KEY)
    return raw ? JSON.parse(raw) : {}
  } catch {
    return {}
  }
}

function getUserSession(): {accessToken?: string; loggedInUsingKeycloakFlow?: boolean} {
  // Prefer the live store; fall back to the persisted blob before Pinia is active.
  if (getActivePinia()) {
    const userStore = useUserStore()
    return {accessToken: userStore.accessToken, loggedInUsingKeycloakFlow: userStore.loggedInUsingKeycloakFlow}
  }

  return getPersistedUserSession()
}

/**
 * Provider of the ACTIVE session: the flow it logged in with (the flag) while a
 * session exists, else the `auth_provider` intent cookie for the next login.
 */
export function isKeycloakSession(): boolean {
  if (!process.client) {
    return false
  }

  const {accessToken, loggedInUsingKeycloakFlow} = getUserSession()
  return accessToken ? Boolean(loggedInUsingKeycloakFlow) : isKeycloakAuth()
}
